<template>
    <!--subscribe start-->
  <section class="subscribe-bg">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-lg-6">
          <div class="subscribe">
            <button type="submit" class="btn btn-email" id="mc-submit">ลงทะเบียนเข้าร่วมงาน</button> 
          </div>
        </div>
        <div class="col-sm-12 col-lg-6">
          <div class="email-box">
              
               <button type="submit" class="btn btn-email" id="mc-submit">ร่วมอวยพร</button> 
              <button type="submit" class="btn btn-email" id="mc-submit">ร่วมบริจาค</button>
            
          </div>
        </div>
      </div>
    </div>
  </section>
    <!--subscribe end -->
</template>
<script>
export default {
  name: 'Subscribe'
}
</script>
